import { FCWithChildren } from 'common/types';

import { useCashflowBankAccountsContext } from '../CashflowBankAccountsContext';

// This component is only used as
// a "cache-loader" for both the
// cashflow Overview and Treasury pages.
// The way it works is by pre-fetching
// the company bank accounts and filling
// Apollo's cache
export const CashflowBankAccountsLoader: FCWithChildren = ({ children }) => {
  const { loading } = useCashflowBankAccountsContext();
  if (loading) {
    return null;
  }

  return children;
};
